// Only initialize the legacy marquee on pages that contain it.
(() => {
  const root = document.documentElement;
  const marqueeContent = document.querySelector("ul.marquee-content");
  if (!marqueeContent || !marqueeContent.children.length) return;
  const items = Array.from(marqueeContent.children);
  const displayed = Math.max(0, parseInt(getComputedStyle(root).getPropertyValue("--marquee-elements-displayed"), 10) || 0);
  root.style.setProperty("--marquee-elements", items.length);
  for (let i = 0; i < displayed; i++) {
    const clone = items[i % items.length].cloneNode(true);
    clone.setAttribute("aria-hidden", "true");
    marqueeContent.appendChild(clone);
  }
})();
